/* src/app/views/home/home.component.scss */
.home {
  box-sizing: border-box;
  position: relative;
}
.home.container {
  padding: 24px;
}
.home.container > .grid {
  margin: 0 !important;
}
.home.container > .grid > [class*=col-] {
  padding-left: 16px;
  padding-right: 16px;
}
.home-main-box {
  width: 100%;
  min-height: 0;
  padding: 24px 20px 18px;
  max-width: 1320px;
  margin: 0 auto;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  box-sizing: border-box;
  overflow: visible;
}
.home-intro {
  width: 100%;
  max-width: 100%;
  margin-bottom: 40px;
  overflow: hidden;
}
.home-title {
  margin: 0;
  font-weight: 500;
  font-style: normal;
  font-size: 48px;
  line-height: 1.05;
  color: #102b4e;
  display: inline-block;
  max-width: 100%;
  letter-spacing: -0.03em;
  white-space: nowrap;
  text-wrap: nowrap;
}
.home-main-content {
  width: 100%;
  min-height: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 4px;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}
.home-actions {
  width: 100%;
  max-width: 1140px;
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  justify-content: stretch;
  align-items: stretch;
  gap: 24px;
  padding: 0;
  box-sizing: border-box;
}
.home-action-item {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
}
.home-action-item--loading {
  pointer-events: none;
}
.home-button-plan {
  width: 100%;
  min-height: 204px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(16, 43, 78, 0.14);
  box-sizing: border-box;
  box-shadow: 0 8px 18px rgba(16, 43, 78, 0.07);
  border-radius: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  text-align: center;
  color: #123d7a;
  cursor: pointer;
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease,
    border-color 0.22s ease,
    background-color 0.22s ease;
}
.home-button-plan:hover,
.home-button-plan:focus-visible {
  transform: translateY(-6px);
  background-color: #ffffff;
  border-color: rgba(4, 108, 234, 0.34);
  box-shadow: 0 10px 22px rgba(4, 108, 234, 0.14);
  outline: none;
}
.home-button-plan:focus {
  text-align: center !important;
}
.home-button-plan--sales .home-icon-wrap {
  background: rgba(4, 108, 234, 0.1);
}
.home-button-plan--search .home-icon-wrap {
  background: rgba(1, 105, 157, 0.1);
}
.home-button-plan--info .home-icon-wrap {
  background: rgba(16, 43, 78, 0.08);
}
.home-button-plan--skeleton {
  background: #f7f9fd;
  border-color: #e3e9f2;
  box-shadow: none;
}
.home-apply-align {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
}
.home-icon-wrap {
  width: 92px;
  height: 92px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #0e4188;
}
.home-icon-wrap--skeleton {
  background: #e7edf5;
}
.home-icon {
  font-size: 3.9rem;
  text-align: center;
  margin: 0;
  padding: 0;
}
.home-button-label {
  display: block;
  max-width: 10ch;
}
.home-button-label--skeleton {
  width: min(160px, 62%);
  height: 22px;
  border-radius: 8px;
  background:
    linear-gradient(
      90deg,
      #e7edf5 0%,
      #f1f5fb 50%,
      #e7edf5 100%);
  background-size: 220px 100%;
  animation: homeSkeletonShimmer 1.2s linear infinite;
}
@keyframes homeSkeletonShimmer {
  0% {
    background-position: -220px 0;
  }
  100% {
    background-position: 220px 0;
  }
}
@media screen and (max-width: 999px) {
  .home.container {
    padding: 16px;
  }
  .home-main-box {
    min-height: 0;
    padding: 18px 14px 14px;
  }
  .home-title {
    line-height: 1.06;
  }
  .home-main-content {
    padding-top: 0;
  }
  .home-actions {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 20px;
  }
  .home-button-plan {
    min-height: 196px;
    padding: 22px;
  }
  .home-icon-wrap {
    width: 82px;
    height: 82px;
  }
  .home-icon {
    font-size: 3.4rem;
  }
}
@media screen and (max-width: 768px) {
  .home.container {
    padding: 10px;
  }
  .home-main-box {
    padding: 16px 12px 12px;
  }
  .home-intro {
    margin-bottom: 26px;
  }
  .home-title {
    line-height: 1.12;
    max-width: 100%;
  }
  .home-main-content {
    padding-top: 0;
  }
  .home-actions {
    grid-template-columns: 1fr;
  }
  .home-button-plan {
    min-height: 180px;
    font-size: 18px;
    padding: 20px;
  }
  .home-button-label {
    max-width: 100%;
  }
  .home-icon {
    font-size: 3rem;
  }
}
@media screen and (max-width: 480px) {
  .home.container {
    padding: 8px;
  }
  .home-main-box {
    padding: 12px 8px 10px;
  }
  .home-title {
    line-height: 1.14;
    max-width: 100%;
  }
  .home-button-plan {
    min-height: 168px;
    padding: 18px;
  }
  .home-icon-wrap {
    width: 72px;
    height: 72px;
  }
  .home-icon {
    font-size: 2.7rem;
  }
}
/*# sourceMappingURL=home.component-A3QD2LOE.css.map */
